import { ElementRef } from '@angular/core';

/**
 * Calculates whether a dropdown should open above or below its trigger element
 * based on available viewport space.
 *
 * @param containerElement - The element ref containing the dropdown trigger
 * @param estimatedDropdownHeight - Expected height of the dropdown in pixels
 * @returns true if dropdown should open above, false if it should open below
 *
 * @example
 * ```typescript
 * const openAbove = calculateDropdownPosition(
 *   this.dropdownContainer(),
 *   parseInt(this.maxDropdownHeight())
 * );
 * this.dropdownOpenAbove.set(openAbove);
 * ```
 */
export function calculateDropdownPosition(
  containerElement: ElementRef<HTMLElement> | undefined,
  estimatedDropdownHeight: number
): boolean {
  if (!containerElement) {
    return false;
  }

  const rect = containerElement.nativeElement.getBoundingClientRect();
  const spaceBelow = window.innerHeight - rect.bottom;
  const spaceAbove = rect.top;

  // Open above if there's not enough space below AND more space above
  return spaceBelow < estimatedDropdownHeight && spaceAbove > spaceBelow;
}
